// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__tKtEQ","row":"ProcedureTreatmentSummary_row__3rlv2"};